export class NoticeReadPutRequest {
  noticeId:string

  constructor(noticeId:string) {
    this.noticeId = noticeId
  }
}
